import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

// Mirrors a relance card so the list keeps its height when the real cards replace it.
export const TaskListSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => (
    <div className="flex flex-col gap-s" data-testid="home-task-skeleton" aria-hidden="true">
        {Array.from({ length: rows }, (_, i) => (
            <div
                key={i}
                className="flex flex-col rounded-lg border border-line-subtle bg-surface-elevated shadow-weak overflow-hidden"
            >
                <div className="flex flex-col gap-xs pt-m px-l">
                    <div className="flex items-center justify-between gap-s">
                        <div className="flex items-center gap-xs w-1/2">
                            <SkeletonBar className="w-4 h-4 shrink-0" />
                            <SkeletonBar className="h-3 flex-1" />
                        </div>
                        <SkeletonBar className="h-3 w-16 shrink-0" />
                    </div>
                    <SkeletonBar className="h-3 w-2/3" />
                </div>
                <div className="flex items-center justify-between gap-s px-l pt-m pb-l">
                    <SkeletonBar className="h-3 w-24" />
                    <SkeletonBar className="h-9 w-28" shape="block" />
                </div>
            </div>
        ))}
    </div>
);
